import styled from "styled-components";
import { Link } from 'react-router-dom';


export const StyledLink = styled(Link)`
background: var(--vidomOrange);
padding: 10px 30px;
font-size: 1em;
color: var(--vidomWhite);
font-weight: 600;
border-radius: 30px;
`
